































import Vue from 'vue'
import { defineComponent, ref, watch, computed, reactive } from '@vue/composition-api'
import { useWrapperClasses, useInputClasses } from './abstractions';

export default defineComponent({
    props: {
        name:        { type: String, required: true },
        value:       { type: String, default: '' },
        label:       { type: String, default: '' },
        error:       { type: Object, default: null },
        placeholder: { type: String, default: '' },
        disabled:    { type: Boolean, default: false },
        readonly:    { type: Boolean, default: false },
        showTogglePwdVisibility: { type: Boolean, default: true },
        actionSequentialFocus:   { type: Boolean, default: false }
    },

    setup(props, context) {
        const state = reactive({
            inputType: 'password'
        });

        const id = props.name;

        const formattedValue = computed(() => props.value);

        const onInput = (evt: Event) => {
            if (evt.target instanceof HTMLInputElement) {
                context.emit('input', evt.target.value);
            }
        };

        const onTogglePwdVisibility = () => state.inputType = state.inputType == 'password' ? 'text' : 'password';

        const togglePwdVisibilityLabel = computed(() => {
            return state.inputType == 'password' ? 'Show password' : 'Hide password';
        });

        const currentWokIcon = computed(() => {
            return state.inputType == 'password' ? 'wok-icon-eye-16' : 'wok-icon-eye-bar-16';
        });

        return {
            state,
            id,
            wrapperClasses : useWrapperClasses(props, context.attrs),
            inputClasses : useInputClasses('password', computed(() => props.showTogglePwdVisibility)),
            formattedValue,
            onInput,
            onTogglePwdVisibility,
            togglePwdVisibilityLabel,
            currentWokIcon
        }
    }
})
